export const SwitchUserOverlay = ({ text }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100vh", // Ensure full viewport height
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        color: "white",
        fontSize: "1.2em",
        fontWeight: "bold",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        textAlign: "center",
        padding: "20px",
      }}
    >
      {text}
    </div>
  );
};